import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '@salesforce/design-system-react';

import BrowserContainer from '../../containers/browserContainer';
import { CONFERENCE_NAME, EMAIL_ADDRESS, DISCOUNT_CODE, EMAIL_BANNER } from '../../constants';

const propTypes = {
  appStarted: PropTypes.bool,
  accessible: PropTypes.bool,
  nextFunc: PropTypes.func
};

class EmailScreen extends Component {

  renderBannerImage() {
    const blankImgSrc = this.props.accessible ? 'assets/images/emailBannerBlankAlt.png' : 'assets/images/image1.png';
    const alt = this.props.accessible ? EMAIL_BANNER : null;
    return (
      <div className='email-banner-container'>
        <img className={classNames('db email-image', {
          'opacity-0': this.props.appStarted 
          })}
          src='assets/images/emailBanner.png'
          alt={alt} 
          aria-hidden = {this.props.appStarted ? 'true' : 'false'}
        />

      <img className={classNames('db email-image', {
        'opacity-0': !this.props.appStarted 
        })} 
        src={blankImgSrc}
        alt={alt}
        aria-hidden = {!this.props.appStarted ? 'true' : 'false'} 
      />
    </div>
    )
  }

  renderDiscountImage() {
    const blankImgSrc = this.props.accessible ? 'assets/images/discountBlankAlt.png' : 'assets/images/image2.png';
    const alt = this.props.accessible ? `Discount Code: ${DISCOUNT_CODE}` : null;
    return (
      <div className='discount-container'>
        <img className={classNames('db email-image', {
          'opacity-0': this.props.appStarted
          })} 
          src='assets/images/discount.png'
          alt={alt} 
          aria-hidden = {this.props.appStarted ? 'true' : 'false'} 
        />

      <img className={classNames('db email-image', {
        'opacity-0': !this.props.appStarted
        })} 
        src={blankImgSrc}
        alt={alt} 
        aria-hidden = {!this.props.appStarted ? 'true' : 'false'} 
      />
    </div>
    )
  }

  render() {
    return (
      <BrowserContainer label='Email'>
        <section>
          <h1 className='pam f4 typography-email border-b-gray'>Register for {CONFERENCE_NAME}!</h1>
          <div className='pas slds-media'>
            <span className='slds-media__figure'>
              <img src='assets/images/blankAvatar.png' alt='' className='bg-gray' />
            </span>
            <div className='f5 slds-media__body'>
              <div>
                <strong>{CONFERENCE_NAME}</strong>
                <span className='phxs'>{`<${EMAIL_ADDRESS}>`}</span>
              </div>
              <span>to me</span>
            </div>
          </div>
        </section>
        <section className='ht-full bg-lightGray'>
          <div className='ht-full slds-clearfix horz-center slds-size_2-of-3 bg-white'>
            {this.renderBannerImage()}
              <div className='fl pal slds-size_2-of-3'>
                <p className='mvl'>Dear Codey,</p>
                <p className='mvl'>{CONFERENCE_NAME} is just around the corner! Register now so you don't miss out on this amazing conference! Because you're a VIP, you qualify for 75% off. Just use the discount code.</p>
                <p>Excited to see you there!</p>
                <p>{CONFERENCE_NAME} Staff</p>
              </div>
              <div className='fr pvl prm mtl slds-size_1-of-3'>
                {this.renderDiscountImage()}
                <Button
                  onClick={this.props.nextFunc}
                  className='mtm phm pvs db horz-center'
                  disabled={!this.props.appStarted || this.props.nextDisabled}
                  label='Register Now'
                  variant='brand'
                />
            </div>
          </div>
        </section>
      </BrowserContainer>
    );
  }
}

EmailScreen.propTypes = propTypes;
export default EmailScreen;




// WEBPACK FOOTER //
// ./src/steps/altText/emailScreen.js